module.exports = __webpack_public_path__ + "img/abstract-shapes-18.0698748f.svg";